VjsAdmin = (function (self) {
    // eslint-disable-next-line no-multi-assign
    const me = (self.BulkLessonAssign = {});
    const $table = $('#bulk-lesson-table');

    me.init = () => {
        const primaryManagerSelect = $('#primary-manager');
        me.dualListbox = new DualListbox('#manager-dual-list', {
            addEvent(value) {
                const selectedName = $(`option[value=${value}]`).text();
                primaryManagerSelect.append(`
                    <option value="${value}">${selectedName}</option>
                `);
            },
            removeEvent(value) {
                primaryManagerSelect.find(`option[value=${value}]`).remove();
            },
            availableTitle: 'Available Managers',
            selectedTitle: 'Selected Managers',
        });

        // setting default due date to 60 days? They can change it if they want.
        const assignButton = document.querySelector('#assign-lessons');
        assignButton.addEventListener('click', () => {
            const daysSelect = document.querySelector('#days-until-due');
            const daysUntilDue = daysSelect.options[daysSelect.selectedIndex].value;

            // managers from dual list - spread HTML element options into array then map the values
            const primaryManager = document.querySelector('#primary-manager').value;
            const selectedManagers = [...document.querySelector('#manager-dual-list').selectedOptions].map((a) => a.value);
            const lessonSelections = [...$table.bootstrapTable('getSelections')].map((l) => l.id);

            if (!primaryManager || lessonSelections.length < 1) {
                VjsUtility.Notification.error({
                    text: 'No manager or lessons, complete form',
                    time: 7000,
                });

                return;
            }

            const req = new VjsUtility.Request();
            req.post(
                Slim.Router.pathFor('platforms.districts.licenses.lessons.saveBulkAssignmentTemplate', {
                    district_id: $table.data('district-id'),
                    district_joint_guid: $table.data('district-joint-guid'),
                    license_id: $table.data('license-id'),
                    platform_id: $table.data('platform-id'),
                }),
                {
                    primaryManager,
                    selectedManagers,
                    daysUntilDue,
                    lessonSelections,
                },
            )
                .done((res) => {
                    console.log(res.data);
                    VjsUtility.Notification.success({
                        text: 'Success!',
                        time: 5000,
                    });
                })
                .fail((res) => {
                    console.log(res.error);
                    VjsUtility.Notification.error({
                        text: res.error_message,
                        time: 7000,
                    });
                });
        });
    };

    // need events for when button is clicked to send. will need to reload page after publishing
    // need to make sure the list doesn't populate with stuff that is already published

    return self;
}(VjsAdmin || {}));
